<template>
  <div class="printCont">

    <div :id='title' :style="`width: ${width}px;`" class="printContInner">
      <div v-for="count in page" :key='count' class="page" :style="{'height':(1430/page.length)+'px'}">
      <!-- TODO 需要等待铭子给定样式 更换图片、更改class-->
        <div class='header'>
          <img width="130" v-if="cid===1" src="../../assets/linkPharmacyLogo.png" alt="" class='pic'>
          <span class='qR' v-if="cid===1">{{title}}</span>
        </div>
        <div class="spLineBase"></div>
        <!-- 根据传参 page 来确定页数，每页slot不同，固定slotname printContent-> content-->
        <slot  :name="page==1? 'content' : `content${count}`"></slot>
        <p class="page-break"></p>
      </div>
    </div>
        <!-- <img :src="baseImg" alt=""> -->
  </div>
</template>
<script>

export default {
  name: 'printBase',
  props: {
    title: {
      type: String,
      default: '',
    },
    page: {
      type: Number,
      default: 1,
    },
    width: {
      type: Number,
      default: 1114,
    },
  },
  data() {
    return {
      baseImg: '',
    };
  },
  computed: {
    cid() {
      return this.$store.state.user.info.cid;
    },
  },
  methods: {
    handlePrint() {
      const copy = document.querySelector(`#${this.title}`);// .cloneNode();

      copy.style.display = 'block';

      // html2canvas(copy, {
      //   scale: 3,
      // }).then((canvas) => {
      //   const data = canvas.toDataURL('image/png', 1);// .replace('data:image/png;base64,', '');
      //   this.baseImg = data;
      //   copy.style.display = 'none';

      // });
      this.$print(copy);
      // printJS(this.title, 'html');

      console.log(this.page);
    },
  },
  mounted() {
  },
};
</script>
<style lang="less" scoped>
  .printCont{

   .printContInner{
      // display: none;
      position: absolute;
      top: 0;
      left: -2000px;
      color: #000; //!important
      max-height: 1430px;
      background-color: #fff;
    }
    }
          .page{
            padding: 16px 10px;
            font-family: SimSun;
            // margin-bottom: 20px;

          }

  .page-break {
    page-break-after: always;
  }
  .printTitle{
    font-size: 16px;
    font-weight: bold;
    text-align: center;
    padding-bottom: 8px;
    color: #000
  }
  .minPrintTitle{
    position: absolute;
    right: 20px;
  }
  .minTitle tr td{
    text-align: left;
  }
  .printContent{
    border-collapse: collapse;
    color: #000;
    font-size: 12px;

  }
  .printContent td,th{
    text-align: center;
    position: relative;
    border-color: #000;
    font-weight: 300;
    word-break: break-all;
    padding: 2px 6px;
    font-size: 12px;
    *{
      display: inline-block;
      max-height: 28px;
      overflow:hidden
    }

  }
  .printContent td.alignLeft{
    text-align: left;
  }
  .printContent td.alignNone{
    text-align: none;
  }
  .printContent td span{
    padding: 0 2px 0 2px;
  }
  .leftTop{
    position: absolute;
    left: 20px;
    top: 20px;
  }
  .rightBottom{
    position:absolute;
    right:30px;
    bottom: 10px;
    /* top:5px */
  }
  .signOpinion{
    position:absolute;
    left: 20px;
    top: 10px;
    /* top:-5px; */
  }
  .signContent{
    position:absolute;
    left: 20px;
    top: 40px;
  }
  .printCont table{
    font-size: 12px;
    line-height: 1.5
  }
  .qR {
    margin-top: 35px;
    position: absolute;
    right: 10px;
  }

  .header {
    height: 50px;
    width: 100%;
    display: block;
    position: relative;
    /* display: flex;
    justify-content: space-between; */
  }
  .spLineBase {
    display: block;
    margin-top: 5px;
    margin-bottom: 5px;
    border-top: 1px solid #000;
  }
  .indentationLeft {
    // 左缩进 修改需全局搜索
    margin-left: 10px;
  }
  .indentationRight {
    // 右缩进 修改需全局搜索
    margin-right: 30px;
  }

  // 表格上/下方的摘要信息
  .summary-title {
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    align-items: center;
  }
  .summary-left {
    display: flex;
    flex: 1 1 auto;
    justify-content: flex-start;
  }
  .summary-right {
    display: flex;
    flex: 1 1 auto;
    justify-content: flex-end;
  }
</style>
